import { ArrowUp, ArrowDown } from 'lucide-react';
import type { RankChip } from '../../types/index.js';

/**
 * US-405. Names the recruiter's OWN term — never the model's evidence span,
 * which would echo raw resume text past the redaction boundary (spec §7).
 *
 * Naming the term makes the chip a debugging affordance: a recruiter seeing
 * "fintech experience" on someone who obviously lacks it learns the criterion
 * is wrong. Vague copy ("matches your refinements") can't be verified, so it
 * can't be trusted or corrected.
 */
export function RankChipBadge({ chip }: { chip: RankChip }) {
  const up = chip.direction === 'up';
  return (
    <span
      aria-label={up ? `Ranked higher: ${chip.term}` : `Ranked lower: ${chip.term}`}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ${
        up
          ? 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400'
          : 'bg-amber-500/15 text-amber-600 dark:text-amber-400'
      }`}
    >
      {up ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />}
      {chip.term}
    </span>
  );
}
